import { MAIN_FAQ } from '@smarty-nx/code-utils'

import { FooterItem } from './dashboard-footer.types'

export const footerItems = (marketingUrl: string): FooterItem[] => [
  {
    href: MAIN_FAQ,
    title: 'Support',
    dataTestId: 'footer-support-link',
  },
  {
    href: `${marketingUrl}contact`,
    title: 'Contact us',
    dataTestId: 'footer-contact-link',
  },
  {
    href: `${marketingUrl}priceguide`,
    title: 'Price Guide',
    dataTestId: 'footer-price-guide-link',
  },
  {
    href: `${marketingUrl}terms`,
    title: 'Terms and conditions',
    dataTestId: 'footer-terms-link',
  },
  {
    href: `${marketingUrl}privacy`,
    title: 'Privacy',
    dataTestId: 'footer-privacy-link',
  },
  {
    href: `${marketingUrl}accessibility`,
    title: 'Accessibility',
    dataTestId: 'footer-accessibility-link',
  },
  {
    href: `${marketingUrl}cookies`,
    title: 'Cookies policy',
    dataTestId: 'footer-cookies-link',
  },
  {
    href: '',
    title: 'Cookie preferences',
    dataTestId: 'footer-cookie-preferences',
  },
  {
    href: `${marketingUrl}complaints`,
    title: 'Complaints',
    dataTestId: 'footer-complaints-link',
  },
]
